export const ADMIN_OVERVIEW_PERMISSIONS = Object.freeze({
  CAN_VIEW_ADMIN_OVERVIEW_PAGE: 'can-view-admin-overview-page'
});

export const ADMIN_COLLAB_CREATORS_PERMISSIONS = Object.freeze({
  CAN_VIEW_COLLAB_CREATORS_PAGE: 'can-view-collab-creators-page'
});

export const ADMIN_COLLAB_REQUESTS_PERMISSIONS = Object.freeze({
  CAN_VIEW_ADMIN_COLLAB_REQUESTS_PAGE: 'can-view-admin-collab-requests-page'
});

export const TAG_MANAGEMENT_PERMISSIONS = Object.freeze({
  CAN_VIEW_TAG_MANAGEMENT_PAGE: 'can-view-tag-management-page'
});

export const USERS_PERMISSIONS = Object.freeze({
  CAN_VIEW_USERS_PAGE: 'can-view-users-page'
});

export const SETTINGS_PERMISSIONS = Object.freeze({
  CAN_VIEW_SETTINGS_PAGE: 'can-view-settings-page',
  CAN_VIEW_CHANGE_EMAIL_SECTION: 'can-view-change-email-section',
  CAN_VIEW_CHANGE_PASSWORD_SECTION: 'can-view-change-password-section',
  CAN_VIEW_TOGGLE_PROFILE_OFFLINE_SECTION: 'can-view-toggle-profile-offline-section',
  CAN_VIEW_DELETE_ACCOUNT_SECTION: 'can-view-delete-account-section'
});

export const CHATS_PERMISSIONS = Object.freeze({
  CAN_VIEW_CHATS_PAGE: 'can-view-chats-page',
  CAN_VIEW_ALL_CHATS: 'can-view-all-chats',
  CAN_SEND_CHAT_MESSAGE: 'can-send-chat-message'
});

export const CREATOR_OVERVIEW_PERMISSIONS = Object.freeze({
  CAN_VIEW_CREATOR_OVERVIEW_PAGE: 'can-view-creator-overview-page'
});

export const EDIT_PROFILE_PERMISSIONS = Object.freeze({
  CAN_VIEW_EDIT_PROFILE_PAGE: 'can-view-edit-profile-page'
});

export const EDIT_CONTACT_PERMISSIONS = Object.freeze({
  CAN_VIEW_EDIT_CONTACT_PAGE: 'can-view-edit-contact-page'
});

export const CREATOR_COLLAB_REQUESTS_PERMISSIONS = Object.freeze({
  CAN_VIEW_CREATOR_COLLAB_REQUESTS_PAGE: 'can-view-creator-collab-requests-page'
});

export const INVITE_REQUESTS_PERMISSIONS = Object.freeze({
  CAN_VIEW_INVITE_REQUESTS_PAGE: 'can-view-invite-requests-page'
});

export const HOMEPAGE_PERMISSIONS = Object.freeze({
  CAN_REQUEST_COLLAB: 'can-request-collab',
  CAN_SAVE_CREATOR_PROFILE: 'can-save-creator-profile'
});

export const BROADCAST_MESSAGES_PERMISSIONS = Object.freeze({
  CAN_VIEW_BROADCAST_MESSAGES_PAGE: 'can-view-broadcast-messages-page'
});

export const PAGE_PERMISSIONS = Object.freeze({
  ...ADMIN_OVERVIEW_PERMISSIONS,
  ...ADMIN_COLLAB_CREATORS_PERMISSIONS,
  ...TAG_MANAGEMENT_PERMISSIONS,
  ...USERS_PERMISSIONS,
  ...SETTINGS_PERMISSIONS,
  ...CHATS_PERMISSIONS,
  ...CREATOR_OVERVIEW_PERMISSIONS,
  ...EDIT_PROFILE_PERMISSIONS,
  ...EDIT_CONTACT_PERMISSIONS,
  ...CREATOR_COLLAB_REQUESTS_PERMISSIONS,
  ...INVITE_REQUESTS_PERMISSIONS,
  ...ADMIN_COLLAB_REQUESTS_PERMISSIONS,
  ...HOMEPAGE_PERMISSIONS,
  ...BROADCAST_MESSAGES_PERMISSIONS
});